import Decimal from 'decimal.js';
import { format } from 'src/utils/numbers';

export function capitalize(s:string){
  return s.split(' ').map(s=>((s[0]||'').toUpperCase()+s.slice(1))).join(' ');
}

export const toPercentage = (value: number | string | Decimal): string => {
  return format(new Decimal(value).mul(100),2);
}